import React, { useMemo } from "react";
import DataTable from "../../../components/common/datatable/DataTable";
import { Tooltip } from "@mui/material";
// import { Chip } from "@mui/material";
// import AddIcon from '@mui/icons-material/Add';
// import CheckIcon from '@mui/icons-material/Check';
// import CloseIcon from '@mui/icons-material/Close';

const columns = [
  { headerName: "PR Number", field: "prNumber", minWidth: 180 },
  { headerName: "PR Item", field: "prItem", minWidth: 140 },
  { headerName: "Req. Qty", field: "requestedQty", minWidth: 140 },
  { headerName: "Unit", field: "unit", minWidth: 110 },
  { headerName: "Delivery Date", field: "deliveryDate", minWidth: 150 },
  { headerName: "Forecast Qty", field: "forecastQty", minWidth: 160 },
  { headerName: "Supplier Confirmation Qty", field: "supplierConfirmationQty", minWidth: 160 },
  /*
  {
    headerName: "Recommended Action",
    field: "recommendedAction",
    minWidth: 180,
    cellRenderer: ({ value }) => {
      const v = (value || "").toString();
      const normalized = v.trim().toLowerCase();
      const wrap = (node) => (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {node}
        </span>
      );

      if (normalized.includes("create") && normalized.includes("pr")) {
        return wrap(
          <Chip
            icon={<AddIcon sx={{ fontSize: 16, color: 'inherit' }} />}
            label={"Create New PR"}
            size="small"
            sx={{
              backgroundColor: '#8b5cf6',
              color: 'white',
              fontWeight: 600,
              '& .MuiChip-icon': { color: 'white' },
            }}
          />
        );
      }

      if (normalized.includes("cancel") && normalized.includes("pr")) {
        return wrap(
          <Chip
            icon={<CloseIcon sx={{ fontSize: 16, color: 'inherit' }} />}
            label={"Cancel PR"}
            size="small"
            sx={{
              backgroundColor: '#ef4444',
              color: 'white',
              fontWeight: 600,
              '& .MuiChip-icon': { color: 'white' },
            }}
          />
        );
      }

      if (normalized.includes("increase") && (normalized.includes("qty") || normalized.includes("quantity"))) {
        return wrap(
          <Chip
            icon={<AddIcon sx={{ fontSize: 16, color: 'inherit' }} />}
            label={"Increase Qty"}
            size="small"
            sx={{
              backgroundColor: '#f59e0b',
              color: 'white',
              fontWeight: 600,
              '& .MuiChip-icon': { color: 'white' },
            }}
          />
        );
      }

      if (normalized.includes("firm")) {
        return wrap(
          <Chip
            icon={<CheckIcon sx={{ fontSize: 16 }} />}
            label={"Firm PR"}
            size="small"
            color="success"
            sx={{ fontWeight: 600 }}
          />
        );
      }

      return wrap(<span>{value}</span>);
    },
  },
  */
  { headerName: "Recommended Qty", field: "recommendedQty", minWidth: 180 },
  {
    headerName: "Reason",
    field: "reason",
    minWidth: 300,
    cellRenderer: ({ value }) => {
      const text = value ?? "";
      const content = (
        <span
          style={{
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </span>
      );

      if (!text) return content;

      const tooltipContent = (
        <span
          style={{
            display: "block",
            maxWidth: 320,
            whiteSpace: "pre-line",
            wordBreak: "break-word",
          }}
        >
          {text}
        </span>
      );

      return (
        <Tooltip title={tooltipContent} arrow>
          {content}
        </Tooltip>
      );
    },
  },
];

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  flex: 1,
};

const ManagePrsTable = ({ rows = [], onSelectionChange }) => {
  const rowData = useMemo(() => {
    if (!Array.isArray(rows)) return [];
    return rows.map((r, idx) => ({
      id: r.prNumber ? `${r.prNumber}-${r.prItem || idx}` : idx,
      prNumber: r.prNumber,
      prItem: r.prItem,
      requestedQty: r.requestedQty ?? r.reqQty ?? r.requestQty ?? 0,
      unit: r.unit,
      deliveryDate: r.deliveryDate,
      forecastQty: r.forecastQty,
      supplierConfirmationQty: r.supplierConfirmationQty ?? r.supplierQty ?? r.supplierConfirmation ?? 0,
      recommendedAction: r.recommendedAction,
      recommendedQty: r.recommendedQty,
      reason: r.reason,
    }));
  }, [rows]);

  const handleSelectionChanged = (params) => {
    const selected = params?.api?.getSelectedRows?.() || [];
    onSelectionChange?.(selected);
  };

  return (
    <DataTable
      columns={columns}
      rows={rowData}
      height={350}
      paginationProp={true}
      paginationPageSize={10}
      paginationPageSizeSelector={[10, 20, 50, 100]}
      rowSelection="multiple"
      suppressRowClickSelection={false}
      defaultColDef={defaultColDef}
      onSelectionChanged={handleSelectionChanged}
    />
  );
};

export default ManagePrsTable;
